import { call, put, select, takeLatest } from "redux-saga/effects";

import factory from "utils/getApiHandlerEffect";

import { SagaIterator } from "redux-saga";
import {
  afterFetchUserAcceptedTnC,
  afterTnCFetched,
  afterUpdatedTnCAcceptance,
  getTnCForCidpUser,
  removeToken,
  setError,
  setToken,
  setUserAcceptedNewTnC,
} from "./redux";
import storage from "../persistance";
import { selectUserCidpId } from "./selectors";
import { UpdatedTnCAcceptanceResponse } from "services/DTO/CheckUpdatedTermsDTO";

export function* setTokenToSessionStorage(
  action: ReturnType<typeof setToken>
): SagaIterator<void> {
  const apiHandler: APIHandler = yield call(() => factory());
  storage.setItem("SESSION_KEY", action.payload);
  apiHandler.sessionKey = action.payload;
}

export function* removeTokenFromStorage(): SagaIterator<void> {
  const apiHandler: APIHandler = yield call(() => factory());
  storage.removeItem("SESSION_KEY");
  apiHandler.sessionKey = undefined;
}

export function* setUpdatedTncAccepted(): SagaIterator {
  const cidpId = yield select(selectUserCidpId);
  const apiHandler: APIHandler = yield call(() => factory());
  try {
    yield call(() =>
      apiHandler.setAcceptanceForUpdatedTnC(cidpId, { accepted: true })
    );
    yield put(afterUpdatedTnCAcceptance(true));
  } catch (e: any) {
    yield put(afterUpdatedTnCAcceptance(false));
    yield put(setError(true));
  }
}

export function* loadTermsAndConditionsForCidpUser(
  action: ReturnType<typeof getTnCForCidpUser>
): SagaIterator<void> {
  const apiHandler: APIHandler = yield call(() => factory());
  try {
    const cidpId = yield select(selectUserCidpId);
    const hasUserAcceptedTnC: UpdatedTnCAcceptanceResponse = yield call(() =>
      apiHandler.checkUserAcceptedLatestTerms(cidpId)
    );
    yield put(afterFetchUserAcceptedTnC(hasUserAcceptedTnC));

    const termsAndConditionsContent: string = yield call(() =>
      apiHandler.getUpdatedTnC(cidpId)
    );
    const termsAndConditionsAsPlainText = yield call(() =>
      new Response(termsAndConditionsContent).text()
    );

    yield put(
      afterTnCFetched(
        termsAndConditionsAsPlainText !== "success"
          ? termsAndConditionsAsPlainText
          : null
      )
    );
  } catch (e: any) {
    // Handle error if needed
  }
}

export default function* globalSaga() {
  yield takeLatest(setToken.type, setTokenToSessionStorage);
  yield takeLatest(removeToken.type, removeTokenFromStorage);
  yield takeLatest(getTnCForCidpUser.type, loadTermsAndConditionsForCidpUser);
  yield takeLatest(setUserAcceptedNewTnC.type, setUpdatedTncAccepted);
}
